import { Table } from "@kanda-libs/ks-component-ts";
import type { Lead } from "@kanda-libs/ks-frontend-services";
import type { FunctionComponent } from "react";
import LeadTableActions from "../LeadTableActions";
import useLeadTableProps from "./useLeadTableProps";

export interface LeadTableProps {
  leads: Lead[];
}

const LeadTable: FunctionComponent<LeadTableProps> = function ({ leads }) {
  const tableProps = useLeadTableProps(leads);

  return (
    <>
      <LeadTableActions />
      <Table {...tableProps} />
    </>
  );
};

export default LeadTable;
